// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewMoreButton_wrapper__3lT5Z","btn":"ViewMoreButton_btn__3Hpaq"};